var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71014 0.869565C2.15317 0.869565 0.869565 2.15317 0.869565 3.71014V16.2899C0.869565 17.8468 2.15317 19.1304 3.71014 19.1304H16.2899C17.8468 19.1304 19.1304 17.8468 19.1304 16.2899V3.71014C19.1304 2.15317 17.8468 0.869565 16.2899 0.869565H3.71014ZM0 3.71014C0 1.67292 1.67292 0 3.71014 0H16.2899C18.3271 0 20 1.67292 20 3.71014V16.2899C20 18.3271 18.3271 20 16.2899 20H3.71014C1.67292 20 0 18.3271 0 16.2899V3.71014Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2168 8.98576V3.47852H6.08636V8.98576H5.2168Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47784 6.95648H0.869141V6.08691H3.47784V6.95648Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4635 6.95648H7.24609V6.08691H12.4635V6.95648Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8411 6.95648H16.2324V6.08691H18.8411V6.95648Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9121 8.98576V3.47852H14.7817V8.98576H13.9121Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4929 14.2035H6.37695V13.334H14.4929V14.2035Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14921 10.2186C9.33279 10.3734 9.35613 10.6477 9.20135 10.8313L6.7086 13.7878C6.55382 13.9714 6.27952 13.9947 6.09594 13.8399C5.91236 13.6851 5.88901 13.4108 6.0438 13.2273L8.53655 10.2707C8.69133 10.0872 8.96563 10.0638 9.14921 10.2186Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09594 13.1747C6.27952 13.0199 6.55382 13.0432 6.7086 13.2268L9.20135 16.1833C9.35613 16.3669 9.33279 16.6412 9.14921 16.796C8.96563 16.9508 8.69133 16.9274 8.53655 16.7438L6.0438 13.7873C5.88901 13.6037 5.91236 13.3294 6.09594 13.1747Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBackIcon);
export default __webpack_public_path__ + "static/media/calendar-back-icon.e62ecd87e31ecd389963e38eb9508fc9.svg";
export { ForwardRef as ReactComponent };